export default function (id, rotationMin = -30,
// In degrees.
rotationMax = 30,
// In degrees.
translateYMin = -64,
// In px.
translateYMax = 64 // In px.
) {
  const remap = function (value, inMin, inMax, outMin, outMax) {
    return outMin + (value - inMin) * (outMax - outMin) / (inMax - inMin);
  };
  const view = document.getElementById(id);
  const container = view.querySelector('.flex-roundabout,.flex-slider');
  const items = Array.prototype.slice.call(container.children);
  const update = () => {
    const containerRect = container.getBoundingClientRect();
    const containerWidth = containerRect.width;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const itemRect = item.getBoundingClientRect();

      // Offset from the scroll elements left side to the center of the item.
      let itemOffset = itemRect.x - containerRect.x + itemRect.width / 2;
      // Convert the offset to a range of -1 and 1. Where -1 is the item's center on the scroll element's left side, and 1 is the item's center on the scroll element's right side.
      itemOffset = (itemOffset - containerWidth / 2) / (containerWidth / 2);

      // Remap to given rotation.
      const rotation = remap(itemOffset, -1, 1, rotationMin, rotationMax);
      // Add additional smoothing for positioning.
      let translationFactor = itemOffset * itemOffset;
      if (itemOffset < 0) {
        translationFactor = -translationFactor;
      }
      // Remap to given translation.
      const translateY = remap(Math.abs(translationFactor), 0, 1, 1 - translateYMax, 1 - translateYMin);

      // Apply styling to item.
      item.style.transform = 'translateY(' + translateY + 'px) rotate(' + rotation + 'deg)';
    }
  };
  container.addEventListener('scroll', update);
  update();
}
;